import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, UntypedFormControl, Validators, AbstractControl } from '@angular/forms';
import { AccessService } from '../service/access.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import {CustomsValidators} from '../../validators/custom.validators'
import { QualificationsModalComponent } from '../employe-access/qualifications-modal/qualifications-modal.component';
import { ModErrorComponent } from '../modals/mod-error/mod-error.component';
import { ModalExceptionConfirmComponent } from './modal-exception-confirm/modal-exception-confirm.component';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Component({
  selector: 'app-access-exception',
  templateUrl: './access-exception.component.html',
  styleUrls: ['./access-exception.component.css']
})
export class AccessExceptionComponent implements OnInit {
  //forms
  formAccessEmployee: UntypedFormGroup;
  RadioGroup: UntypedFormGroup;

  //calendar
  todayDate: Date;
  maxDate: Date;
  sDate: string;
  eDate: string;
  maxDateTo: Date;

  //service
  buttonEnable: boolean= true
  oneSapZone:string
  oneSapSite:string
  selectZone: any = [];
  site: any=[];
  selectBusiness: any =[];
  selectSubZone: any=[];
  formTableEntry: any;
  selectCountry: any=[];
  description: string=null;
  descriptionSubzone: string=null;
  formRadio: UntypedFormGroup;
  radioPress = false;

  approverFacilityZone: any;
  approverFacilitySubZone: any;

  controlNationalError = false;
  controlCountryError = false;
  controlDateAddError = false;
  controlRepeatPerson = false;
  controlNotFoundError = false;
  controlPeopleInError = false;
  controlSiteZoneCCError = false;

  submited = false;
  dataEntry: any;
  approvers: any;
  siteCC:any;
  zoneCC: any;
  subzoneCC: any;
  options:any[];
  optionsApproverSubzone:any[];
  constructor(private formBuilder: UntypedFormBuilder,
              private dataApi: AccessService,
              private spinner: NgxSpinnerService,
              private _snackBar: MatSnackBar,
              public dialog: MatDialog,
              private datePipe: DatePipe,
              private router: Router)
  {
    this.dataEntry = null;
    this.RadioGroup = new UntypedFormGroup({
      radioBtn: new UntypedFormControl()
    });
    this.RadioGroup.controls['radioBtn'].setValue(String('false'));
    this.formTableEntry = [];
    this.approvers = [];
    this.todayDate = new Date();
    this.maxDate = new Date((this.todayDate.getFullYear() +environment.MaxYeardateAccessForms), this.todayDate.getMonth(),this.todayDate.getDate());
    this.maxDateTo= new Date((this.todayDate.getFullYear() +environment.MaxYeardateAccessForms), this.todayDate.getMonth(),this.todayDate.getDate());
  }

  public toFormControl(point: AbstractControl): UntypedFormControl {
    return point as UntypedFormControl;
   }
  getEmployeeAccess() {
    this.spinner.show("loading");
    this.dataApi.getExceptionAccess().subscribe((data: any) => {
      this.spinner.hide("loading");
      this.site = data.sites;
      this.selectBusiness=data.businessUnits;
      this.selectCountry=data.countries;
    },(err) => {
      this.spinner.hide("loading");
      if(err.error.error !== 'Invalid token.') {
        this.dialog.open(ModErrorComponent, {
          width: 'auto',
          panelClass: 'myapp-no-padding-dialog',
        });
      }

    });
  }
  getlang(){
    return sessionStorage.getItem('lang');
  }
  openDialog() {
    this.dialog.open(ModalExceptionConfirmComponent, {panelClass: 'myapp-no-padding-dialog'}).afterClosed().subscribe((accept: boolean) => {
      if (accept) {
        this.formAccessEmployee.controls['Confirm'].setValue(true);
      }
    });
  }
  seeQualifications(qualifications) {
    this.dialog.open(QualificationsModalComponent, {panelClass: 'myapp-no-padding-dialog', data: qualifications });
  }
  changeLimitDate(){

    switch(this.formAccessEmployee.controls['dateIndefinite'].value){
      case true:
        let dateToSelected =new Date( this.formAccessEmployee.controls['dateStart'].value)
        let dateUndefined = new Date (dateToSelected.setFullYear(dateToSelected.getFullYear()+environment.MaxYeardateAccessForms))
        this.formAccessEmployee.patchValue({dateEnd: dateUndefined})
        break;
      case false:
        this.formAccessEmployee.controls['dateEnd'].setValue("")
        break;
    }
  }
  ngOnInit() {
    this.formRadio = this.formBuilder.group({
      options: ['nationalId', Validators.required],
      ID: ['', [Validators.required,Validators.maxLength(10), CustomsValidators.validateRUN]],
      document:['', Validators.required],
      countryId:['', Validators.required]
    });
    this.formAccessEmployee = this.formBuilder.group({
      siteId: ['', Validators.required],
      zoneId: ['', Validators.required],
      subZoneId: ['',Validators.required],
      bussinesUnitID: ['', Validators.required],
      accessApproverId: ['', Validators.required],
      purpuse: [''],
      Confirm: [false, Validators.required],
      dateStart: ['', Validators.required],
      dateEnd: ['', Validators.required],
      facilityApproverId: [''],
      facilityPriority:  [true],
      dateIndefinite: [false]
    });
    this.getEmployeeAccess();
  }
  changeSelectSite(siteId){
    this.ApproverId.setValue([]);
    this.dataEntry=null;
    this.approverFacilityZone=null;
    this.approverFacilitySubZone=null;
    for(const siteOP of this.site){
      if(siteOP.id === Number(siteId)){
        this.selectZone = siteOP.zones;
        this.siteCC = siteOP.codeCC;
        this.oneSapSite= siteOP.code1Sap;

        if (this.oneSapSite==='0000')
        {
          
          this.buttonEnable = false
         
        }
        else 
        {
          this.buttonEnable= true

        }


      }
      this.formAccessEmployee.controls['zoneId'].setValue('');
      this.cleanSubzoneBU();
      this.description = null;
    }
  }

  cleanSubzoneBU(){

    this.dataEntry=null;
    this.formAccessEmployee.controls['accessApproverId'].setValue('');
    this.formAccessEmployee.controls['bussinesUnitID'].setValue('');
    this.formAccessEmployee.controls['subZoneId'].setValue('');
    this.descriptionSubzone = null;
    this.approverFacilitySubZone=null;

  }


  changeSelectZone( zoneId ){
    this.dataEntry=null;
    for(const zoneOP of this.selectZone) {
      if(zoneOP.id === Number(zoneId)) {
        if(zoneOP.subZones === undefined) {
          this.selectSubZone = [];
          this.oneSapZone= null;
        } else {
          this.selectSubZone = zoneOP.subZones;
          this.zoneCC= zoneOP.codeCC;
        }
        this.description = zoneOP.description;
        this.oneSapZone= zoneOP.code1Sap;
        //if(zoneOP.facilityState){ //facility enabled
        if(false){ //facility disabled

          this.spinner.show("loading");
          this.dataApi.getPeopleSearchByMDMID(zoneOP.approverId).subscribe(
            (response: any)=>{
              this.approverFacilityZone= { //llamada al get por mdmid
                fullName: response.firstName+ " "+ response.lastName,
                email: response.email,
                phone: response.phoneNumber,
                priority: zoneOP.priority,
                state: zoneOP.facilityState,
                mdmid: zoneOP.approverId
              }
              this.spinner.hide("loading");
            },
            () => {
              this.spinner.hide("loading");
              this.dialog.open(ModErrorComponent, {
                width: 'auto',
                panelClass: 'myapp-no-padding-dialog',

              });
            }
          )
        }else{
          this.approverFacilityZone=null;
        }
      }
      this.cleanSubzoneBU();
    }
  }
  getApproverSubZone(idSubzone){
    this.dataEntry=null;
    this.formAccessEmployee.controls['accessApproverId'].setValue('');
    for(const subZoneOP of this.selectSubZone){

      if(subZoneOP.id === Number(idSubzone)){
        if(subZoneOP.description === undefined) {
          this.descriptionSubzone = null;
        } else {
          this.descriptionSubzone = subZoneOP.description;
          this.subzoneCC = subZoneOP.codeCC;
        }
        //if(subZoneOP.facilityState){ //facility enabled
        if(false){ //facility disabled
          this.spinner.show("loading");
          this.dataApi.getPeopleSearchByMDMID(subZoneOP.approverId).subscribe(
            (response: any)=>{
              this.approverFacilitySubZone= { //llamada al get por mdmid
                fullName: response.firstName+ " "+ response.lastName,
                email: response.email,
                phone: response.phoneNumber,
                priority: subZoneOP.priority,
                state: subZoneOP.facilityState,
                mdmid: subZoneOP.approverId
              }
              this.spinner.hide("loading");
            },
            () => {
              this.spinner.hide("loading");
              this.dialog.open(ModErrorComponent, {
                width: 'auto',
                panelClass: 'myapp-no-padding-dialog',

              });
            }
          )
        }else{
          this.approverFacilitySubZone=null;
        }
      }
    }
    this.spinner.show("loading");
    this.dataApi.getApproverSubZone(idSubzone).subscribe((data: any) => {
      this.spinner.hide("loading");
      if(data === undefined || data === null){
        this.approvers = [];
        this.optionsApproverSubzone= []
        this.filteredOptionsApproverSubzone = this.formAccessEmployee.controls.accessApproverId.valueChanges
        .pipe(
          startWith(''),
          map(value => typeof value === 'string' ? value : value.name),
          map(name => name ? this._filterSubzoneApprovers(name) : this.optionsApproverSubzone.slice())
        );
      } else {
        this.approvers = data;
        this.optionsApproverSubzone= data.sort((a, b) => a[data.name] > b[data.name] ? 1 : a[data.name] === b[data.name] ? 0 : -1);;
        this.filteredOptionsApproverSubzone = this.formAccessEmployee.controls.accessApproverId.valueChanges
        .pipe(
          startWith(''),
          map(value => typeof value === 'string' ? value : value.name),
          map(name => name ? this._filterSubzoneApprovers(name) : this.optionsApproverSubzone.slice())
        );
      }
    }, (err) => {
      this.spinner.hide("loading");
      if(err.error.error !== 'Invalid token.') {
        this.dialog.open(ModErrorComponent, {
          width: 'auto',
          panelClass: 'myapp-no-padding-dialog',
        });
      }
    });
  }
  changeBuGetApprover(idBu){

    this.formAccessEmployee.controls.accessApproverId.setValue('');
    this.spinner.show("loading");
    this.dataApi.getApproverBu(idBu,this.oneSapSite, this.oneSapZone).subscribe((data: any) => {
      this.spinner.hide("loading");
      if(data === undefined || data === null){
        this.approvers = [];
      } else {
        this.approvers = data;
      }
    }, (err) => {
      this.spinner.hide("loading");
      if(err.error.error !== 'Invalid token.') {
        this.dialog.open(ModErrorComponent, {
          width: 'auto',
          panelClass: 'myapp-no-padding-dialog',
        });
      }
    });
  }

  changeNotBuGetApprover(idZone) {
    this.ApproverId.setValue([]);
    this.changeSelectZone(idZone)
    this.formAccessEmployee.controls.accessApproverId.setValue('');
    this.spinner.show("loading");
    //this.oneSapZone=idZone;
    this.dataApi.getApproversNotBu(this.oneSapSite, this.oneSapZone, 1).subscribe((data: any) => {
      this.spinner.hide("loading");
      if (data === undefined || data === null) {
        this.approvers = [];
      } else {
        this.approvers = data;
        this.options= data;
        this.filteredOptions = this.ApproverId.valueChanges
        .pipe(
          startWith(''),
          map(value => typeof value === 'string' ? value : value.name),
          map(name => name ? this._filter(name) : this.options.slice())
        );
      }
    }, (err) => {
      this.spinner.hide("loading");
      if(err.error.error !== 'Invalid token.') {
        this.dialog.open(ModErrorComponent, {
          width: 'auto',
          panelClass: 'myapp-no-padding-dialog',
        });
      }
    });
  }

      //dropdown

    // myControl = new FormControl();
    ApproverId= new UntypedFormControl([Validators.required])
    // options= this.approvers;
    filteredOptions: Observable<any>;
    filteredOptionsApproverSubzone: Observable<any>;
    private _filterSubzoneApprovers(name: string): any[] {
    const filterValue = name.toLowerCase();
    const devolver = this.optionsApproverSubzone.filter(option => option.name.toLowerCase().indexOf(filterValue) === 0);
      return  devolver;
    }
    displayFn(user: any): string {
      return user.mdmid && user.name ? user.name : '';
    }

    private _filter(name: string): any[] {
      const filterValue = name.toLowerCase();

      return this.options.filter(option => option.name.toLowerCase().indexOf(filterValue) === 0);
    }


  clearPersonDate(){
    let dateToSelected =new Date( this.formAccessEmployee.controls['dateStart'].value)
    this.maxDateTo = new Date (dateToSelected.setFullYear(dateToSelected.getFullYear()+environment.MaxYeardateAccessForms))
    this.formAccessEmployee.controls['dateEnd'].setValue('')
    this.formAccessEmployee.controls['dateIndefinite'].setValue(false)
    this.dataEntry=null;
  }
  goTo(id: string) {
    const el = document.getElementById(id);
    el.scrollIntoView();
  }
  add(){
    this.spinner.show("loading");
    this.radioPress = true;
    this.controlPeopleInError= false;
    this.controlNationalError = false;
    this.controlDateAddError = false;
    this.controlRepeatPerson = false;
    this.controlNotFoundError = false;
    this.controlCountryError=false;
    this.controlSiteZoneCCError= false;
    let doSearch = true;
    if(this.formAccessEmployee.controls['siteId'].hasError('required') || this.formAccessEmployee.controls['zoneId'].hasError('required')
    || (this.formAccessEmployee.controls['subZoneId'].hasError('required') && this.RadioGroup.value.radioBtn === 'true')
    ){
      this.spinner.hide("loading");
      this.controlSiteZoneCCError = true;
      return;
    }

    if(this.formAccessEmployee.controls['dateStart'].hasError('required') ||
      this.formAccessEmployee.controls['dateEnd'].hasError('required')){
      this.controlDateAddError = true;
      this.spinner.hide("loading");
      this.goTo('subzoneQ');
      return;
    }
    if (this.formRadio.value.document === 'nationalId' && this.formRadio.controls['ID'].hasError('validateRUN')) {
      this.spinner.hide("loading");
      return;
    }
    if(!this.formRadio.controls['document'].hasError('required')) {
      if(!this.formRadio.controls['ID'].hasError('required')) {
        if (this.formRadio.value.document === 'passportNumber' &&
          this.formRadio.controls['countryId'].hasError('required')){ //validation of nationality pending
          this.spinner.hide("loading");
          this.controlCountryError = true;
          return;
        }
        if(this.dataEntry){
          if(this.dataEntry.nationalId !='' && this.formRadio.value.document==='nationalId'){
            if(String(this.dataEntry.nationalId).toLowerCase()  === String(this.formRadio.value.ID).toLowerCase() ){
              doSearch = false;
              this.spinner.hide("loading");
            }
          } else if(this.dataEntry.passportNumber != '' && this.formRadio.value.document==='passportNumber'){
            if(String(this.dataEntry.passportNumber).toLowerCase()  === String(this.formRadio.value.ID).toLowerCase()
              && (String(this.formRadio.value.countryId) === this.dataEntry.nationality)){
              doSearch = false;
              this.spinner.hide("loading");
            }
          }
        }
        let accessGroup = this.siteCC + '_' + this.zoneCC ;
        let siteRequest = {
          zoneId: this.formAccessEmployee.controls['zoneId'].value,
          subzoneId: null
        }
        if(this.RadioGroup.value.radioBtn=='true'){
          accessGroup = accessGroup + '_' + this.subzoneCC;
          siteRequest.subzoneId= this.formAccessEmployee.controls['subZoneId'].value
        }


        if(doSearch){
          if (this.formRadio.value.document === 'nationalId') {
            let IdSPLIT = this.formRadio.value.ID.split('.').join('')
            this.formRadio.controls['ID'].setValue(IdSPLIT)
          }
          this.dataApi.getExceptionPeople(this.formRadio.value.document, this.formRadio.value.ID.toLowerCase() ,this.formRadio.value.countryId ,
                                          this.transformDate(this.formAccessEmployee.value.dateStart),
                                          this.transformDate(this.formAccessEmployee.value.dateEnd) , accessGroup, siteRequest).subscribe((data: any) =>
          {
            if(data.status=== 2){ //notFound Code:3
              this.controlNotFoundError = true;
            } else {
              this.dataEntry = data;
            }
            this.spinner.hide("loading");
          },(err) => {
            this.spinner.hide("loading");
            if(err.error.error !== 'Invalid token.') {
              this.dialog.open(ModErrorComponent, {
                width: 'auto',
                panelClass: 'myapp-no-padding-dialog',
              });
            }
          });
        } else {
          this.spinner.hide("loading");
          this.controlRepeatPerson = true;
        }
      } else { this.spinner.hide("loading"); }
    } else {  this.spinner.hide("loading");};
  }

  transformDate(date: Date){
    return(this.datePipe.transform(date, 'yyyy-MM-dd'));
  }


  validationCep60001day(){
    if(this.zoneCC =="CEP" && ((this.formAccessEmployee.controls['dateEnd'].value- this.formAccessEmployee.controls['dateStart'].value)> 86400000)){
      return true;
    }
    return false;
  }

  validation48hours(){

      let dateToday = new Date();
      if(this.formAccessEmployee.controls['dateStart'].value== '' || this.formAccessEmployee.controls['dateStart'].value== undefined ){
        return  false;
      }
      const startDate  = new Date(this.datePipe.transform(this.formAccessEmployee.controls['dateStart'].value, "MM/dd/yyyy"));
      const today  = new Date(this.datePipe.transform(dateToday, "MM/dd/yyyy"));
      let Difference_In_Days48 = (startDate.getTime() - today.getTime()) / (1000 * 3600 * 24);
      if (Difference_In_Days48 <= 2) {
        return  true;
      } else {
        return  false;
      }

  }

  isMandatory(){
    if (this.dataEntry.qualifications==null || this.dataEntry.qualifications==undefined){
      return false;
    }
    for(let qual of this.dataEntry.qualifications){
       if(qual.status==2 && qual.mandatory==true){
        return true;
       }
    }
    return false;
}



  onSubmit(){
    this.spinner.show("loading");
    this.submited=true;
    this.controlPeopleInError = false;
    if(this.formAccessEmployee.controls['siteId'].hasError('required') ||
      this.formAccessEmployee.controls['zoneId'].hasError('required')){
      this.goTo('siteSection');
      this.spinner.hide("loading");
      return;
    }
    if (this.RadioGroup.value.radioBtn === 'true' && (this.formAccessEmployee.controls['subZoneId'].hasError('required') || this.formAccessEmployee.controls['accessApproverId'].hasError('required'))
    ){
      this.goTo('subzoneQ');
      this.spinner.hide("loading");
      return;
    }
    if (this.RadioGroup.value.radioBtn === 'false' && (this.ApproverId.value.mdmid==='' || this.ApproverId.value.mdmid===undefined || this.ApproverId.value.mdmid===null))
    {

      this.goTo('subzoneQ');
      this.spinner.hide("loading");
      return;
    }
    if(this.formAccessEmployee.controls['dateStart'].hasError('required') ||
         this.formAccessEmployee.controls['dateEnd'].hasError('required')) {
      this.goTo('subzoneQ');
      this.spinner.hide("loading");
      return;
    }
    //validation cep 6000 max 1 day
    if(this.validationCep60001day()){
      this.goTo('subzoneQ');
      this.spinner.hide("loading");
      return;
    }

    if (this.RadioGroup.value.radioBtn === 'true' && (this.formAccessEmployee.controls['accessApproverId'].value.mdmid==='' || this.formAccessEmployee.controls['accessApproverId'].value.mdmid===undefined || this.formAccessEmployee.controls['accessApproverId'].value.mdmid===null))
    {
      this.goTo('subzoneQ');
      this.spinner.hide("loading");
      return;
    }

    if (this.formRadio.value.document === 'nationalId' && this.formRadio.controls['ID'].hasError('validateRUN')) {
      this.goTo('document');
      this.spinner.hide("loading");
      return;
    }


    const AccessRequest = {
      requestorId: 1,
      siteId: Number(this.formAccessEmployee.value.siteId),
      zoneId:  Number(this.formAccessEmployee.value.zoneId),
      subZoneId:  Number(this.formAccessEmployee.value.subZoneId),
      businessUnitId:  String(this.formAccessEmployee.value.bussinesUnitID),
      accessApproverId: this.RadioGroup.value.radioBtn === 'false' ? this.ApproverId.value.mdmid : this.formAccessEmployee.value.accessApproverId.mdmid,
      purpose: this.formAccessEmployee.value.purpuse,
      periodFrom:  this.transformDate(this.formAccessEmployee.value.dateStart),
      periodTo: this.transformDate( this.formAccessEmployee.value.dateEnd),
      facilityApproverId: this.formAccessEmployee.value.facilityApproverId,
      facilityPriority:  this.formAccessEmployee.value.facilityPriority,
      people: []
    }
    if(!(this.dataEntry === null || this.dataEntry === undefined)){
      if(this.dataEntry.status === 0){
        AccessRequest.people.push(this.dataEntry.mdmid);
      }
    }
    if(this.approverFacilityZone && this.approverFacilityZone.state && this.RadioGroup.value.radioBtn=='false'){
      AccessRequest.facilityApproverId = this.approverFacilityZone.mdmid;
      AccessRequest.facilityPriority = this.approverFacilityZone.priority;
    }else{
      if(this.approverFacilitySubZone && this.approverFacilitySubZone.state &&
        this.RadioGroup.value.radioBtn == 'true'){
          AccessRequest.facilityApproverId = this.approverFacilitySubZone.mdmid;
          AccessRequest.facilityPriority = this.approverFacilitySubZone.priority;
      }
    }



    if(AccessRequest.people.length === 0 || AccessRequest.people === null){
      this.controlPeopleInError = true;
      this.spinner.hide("loading");
      return;
    }
    if(AccessRequest.people.length > 1){
      this._snackBar.open('you can enter a maximum of 1 person', '', {
        duration: 3000,
      });
      return;
    }
    if(this.formAccessEmployee.controls['Confirm'].hasError('required')  ||
        this.formAccessEmployee.controls['Confirm'].value === false ) {
      this.spinner.hide("loading");
      return;
    }

     this.dataApi.postException(AccessRequest).subscribe((response)=>{
       this.router.navigate(['/access-confirmation/'+ response.requestNumber]);
       this.spinner.hide("loading");
     },(err)=>{
       this.spinner.hide("loading");
       if(err.error.error !== 'Invalid token.') {
        this.dialog.open(ModErrorComponent, {
          width: 'auto',
          panelClass: 'myapp-no-padding-dialog',
        });
      }
     })
  }

}
